import { DEMO_REQUESTED_SESSION_KEY } from '@/constants/session-storage';
import { useState } from 'react';
import { useSessionstorageState } from 'rooks';
import { DemoFormStepOneFields } from './DemoFormStepOne';
import { DemoFormStepTwoFields } from './DemoFormStepTwo';

export enum DemoFormSteps {
  FormStepOne = 'initial-form',
  FormStepTwo = 'secondary-form',
  Scheduler = 'scheduler',
  Confirmation = 'confirmation',
}

export const useDemoFormSteps = () => {
  const [currentStep, setCurrentStep] = useState<DemoFormSteps>(DemoFormSteps.FormStepOne);
  const [demoStepOneFormData, setdemoStepOneFormData] = useState<DemoFormStepOneFields | null>(null);
  const [demoStepTwoFormData, setdemoStepTwoFormData] = useState<DemoFormStepTwoFields | null>(null);
  const [meetingOffered, setMeetingOffered] = useState<boolean>(false);
  const [, setDidRequestDemo] = useSessionstorageState<boolean>(DEMO_REQUESTED_SESSION_KEY, false);

  const incrementInitialDemoFormStep = (values: DemoFormStepOneFields) => {
    setDidRequestDemo(true);
    setdemoStepOneFormData(values);
    setCurrentStep(DemoFormSteps.FormStepTwo);
  };

  const incrementSecondaryDemoFormStep = (values: DemoFormStepTwoFields, meetingOffered: boolean) => {
    setMeetingOffered(meetingOffered);
    setdemoStepTwoFormData(values);
    if (meetingOffered) {
      setCurrentStep(DemoFormSteps.Scheduler);
    } else {
      setCurrentStep(DemoFormSteps.Confirmation);
    }
  };

  return {
    currentStep,
    demoStepOneFormData,
    demoStepTwoFormData,
    meetingOffered,
    setCurrentStep,
    incrementInitialDemoFormStep,
    incrementSecondaryDemoFormStep,
  };
};
